import { connect } from 'react-redux'
import TinyPressureMonitorChart from '../components/charts/TinyPressureMonitorChart'
import { getPressureMonitorDataAction } from '../actions/pressureMonitorsActions'
import { getVisiblePressureMonitorData } from '../reducers/pressureMonitorsReducer'
import { isChartDataLoading } from '../reducers/uiReducer'

const mapStateToProps = ({ pressureMonitors, ui }) => ({
  pressureMonitorData: getVisiblePressureMonitorData(pressureMonitors),
  isChartDataLoading: isChartDataLoading(ui),
})

const mapDispatchToProps = dispatch => ({
  getPressureMonitorData: (pillarId, qs) =>
    dispatch(getPressureMonitorDataAction.request({ pillarId, qs })),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyPressureMonitorChart)
